import { render, staticRenderFns } from "./PaymentPlanDetailTable.vue?vue&type=template&id=5c8189ce&scoped=true&"
import script from "./PaymentPlanDetailTable.vue?vue&type=script&lang=ts&"
export * from "./PaymentPlanDetailTable.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentPlanDetailTable.vue?vue&type=style&index=0&id=5c8189ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8189ce",
  null
  
)

export default component.exports